var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { UserType } from "healthex-common/user.dtos";
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { validators } from "../Logic/Validators";
import { FormModel } from "./FormModel";
export class WelcomeCustomizeOrgDetailsFormViewModel {
    constructor(opts) {
        this.formModel = new FormModel({
            logo: null,
            noPatientPortal: false,
            patientPortalName: "",
            patientPortalLink: "",
            address: "",
            city: "",
            state: null,
            zip: "",
        }, ["patientPortalName", "logo", "address", "city", "state", "zip"]);
        this.organization = NOT_LOADED;
        this.organizationsManager = opts.container.organizationsManager;
        this.onSave = opts.onSave;
        void this.loadOrganization();
    }
    get isFormValid() {
        return this.formModel.isFormValid();
    }
    async loadOrganization(reload) {
        try {
            if (reload) {
                await this.organizationsManager.myOrganization.waitForReload();
            }
            else {
                await this.organizationsManager.myOrganization.waitForValue();
            }
            const organization = this.organizationsManager.myOrganization.value;
            if (organization === NOT_LOADED)
                return;
            if (!organization)
                return;
            if (organization.type !== UserType.HEALTHCARE_ORGANIZATION)
                return;
            this.organization = organization;
            const { logoUrl, patientPortalName, patientPortalLink, address, city, state, zip } = organization;
            this.formModel.input = {
                logo: logoUrl,
                noPatientPortal: patientPortalName === null,
                patientPortalName: patientPortalName !== null && patientPortalName !== void 0 ? patientPortalName : "",
                patientPortalLink: patientPortalLink !== null && patientPortalLink !== void 0 ? patientPortalLink : "",
                address: address !== null && address !== void 0 ? address : "",
                city: city !== null && city !== void 0 ? city : "",
                state: state !== null && state !== void 0 ? state : null,
                zip: zip !== null && zip !== void 0 ? zip : "",
            };
        }
        catch (e) {
            console.error(e);
        }
    }
    validateInput() {
        this.formModel.clearErrors();
        const { notBlank, notNull, validURL } = validators;
        const f = this.formModel;
        if (!f.input.noPatientPortal)
            f.validateField("patientPortalName", notBlank, "Enter your patient portal's name or check the box above");
        f.validateField("logo", notNull, "Upload a logo for your organization");
        f.validateField("patientPortalLink", validURL, "Enter a valid URL");
        return !f.hasErrors();
    }
    async save() {
        const success = await this.performUpdate();
        if (success) {
            await this.loadOrganization(true);
            this.onSave();
        }
    }
    async performUpdate() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return false;
        if (!this.validateInput())
            return false;
        const { logo, patientPortalName, patientPortalLink, address, city, state, zip } = this.formModel.input;
        const updatedOrganization = {
            type: UserType.HEALTHCARE_ORGANIZATION,
            logo,
            patientPortalName: patientPortalName.length ? patientPortalName : null,
            patientPortalLink: patientPortalLink.length ? patientPortalLink : null,
            setupComplete: true,
            address,
            city,
            state,
            zip,
        };
        await this.organizationsManager.editOrganization(this.organization.id, updatedOrganization);
        return true;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], WelcomeCustomizeOrgDetailsFormViewModel.prototype, "organization", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeCustomizeOrgDetailsFormViewModel.prototype, "isFormValid", null);
